export function count<T>(
  iterable: Iterable<T>,
  value: T | ((item: T) => boolean)
): number {
  let count = 0
  const predicate =
    typeof value === 'function'
      ? (value as (item: T) => boolean)
      : (item: T) => item === value

  for (const item of iterable) if (predicate(item)) count++

  return count
}
